import { render, staticRenderFns } from "./chat-emoji-picker.vue?vue&type=template&id=57c70787&scoped=true"
import script from "./chat-emoji-picker.vue?vue&type=script&lang=js"
export * from "./chat-emoji-picker.vue?vue&type=script&lang=js"
import style0 from "./chat-emoji-picker.vue?vue&type=style&index=0&id=57c70787&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c70787",
  null
  
)

export default component.exports